import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchHistoryData } from "../../apis/history";

export const fetchHistory = createAsyncThunk(
  "history/fetchHistory",
  async (
    { keyId, tableName }: { keyId: string; tableName: string },
    { rejectWithValue }
  ) => {
    try {
      const history = await fetchHistoryData(keyId, tableName);
      return history;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
